import React, { Component, createRef } from "react";
import "./SellerDeclaration.css";
import Error from "../Error/Error";
import { getApiData } from "../../api/api";
// import axios from "axios";
import { generateInputs } from "../../utils/inputGeneratorForQuestions";
import { questions } from "../../utils/questions";
import DeclarationText from "./Declaration";
import InfoPopUp from "./InfoPopUp";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AxiosRequest from "../../utils/axios";
import { getConfigFromParamStore, getConfigFromStroage } from "../../utils/getUrlsFromAws";
import DotsLoader from "../Loader/DotsLoader/DotsLoader";
import { Button, RadioButton } from "unified-ui-components-library";
import { isIOSDevice } from "../../utils/getDevice";
import BenefitIllustration from "../BenefitIllustration/BenefitIllustration";
import SDOtp from "./SDOtp";
import { jwtDecode } from "jwt-decode";
import IdleTimer from "react-idle-timer";
import { IDLE_USER_TIMEOUT } from "../../utils/constants";

const axios = new AxiosRequest().getClient()

class SellerDeclaration extends Component {
  constructor(props) {
    super(props);
    this.idleTimerRef = createRef();
    this.state = {
      errMsg: "",
      err: false,
      mandatoryError: "Please complete Agent confidential report & Moral hazard questionnaire",
      disableButtons: false,
      displayQuestions: false,
      sellerDisclosure: "",
      sellerNonDisclosure: "",
      successMsg: "",
      period: "",
      periodUnit: "",
      questions: questions,
      spName: '',
      showPopup: false,
      popupMsg: "",
      popupFor: "",
      loading: true,
      declaration: false,
      info: false,
      requiredQuestion1: true,
      requiredQuestion2: true,
      productName: "",
      productType: "",
      showDeclarationForCancer: false,
      solIdList: [],
      filteredOptions: [],
      selectedFromList: null,
      selectedValue: "",
      requestSource: ""
    };
  }

  componentDidMount() {
    this.initialize()
  }


  checkForCancerPlanAndProductType = (productName, productType) => {
    let cancerPlanName = "Max Life Cancer Insurance Plan"
    if (productName.toLowerCase() == cancerPlanName.toLowerCase()) {
      this.setState({ showDeclarationForCancer: true })
      return
    } else if (productType.toLowerCase() == "trad" || productType.toLowerCase() == "combo") {
      this.setState({ showDeclarationForCancer: false })
      return
    } else {
      this.setState({ showDeclarationForCancer: true })
    }
  }

  initialize = async () => {
    let urlsData = getConfigFromStroage();
    if (!urlsData) {
      const resp = await getConfigFromParamStore()
    }
    let [param, payload] = window.location.search.split('=')
    console.log("param", param);
    this.setState({ loading: true })
    let { url, body } = getApiData('sellerConsentDetails')
    body.request.payload.encryptedValue = payload
    // console.log(url, body)
    axios.post(url, body).then(response => {
      if (response.data.response.msgInfo.msgCode == 200) {
        const { productType, productName, spName, solIdList, solId, requestSource, isCasePassedStageFour, pfS3Path, showOtpPage, proposalNo } = response.data.response.payload
        const { jwtToken } = response.data.response.header
        this.setState({ jwtToken })
        let dataFromToken = {}
        if (jwtToken) {
          const decodedData = jwtDecode(jwtToken)
          dataFromToken = decodedData
        }

        let defaultSolId = solId ? solId.toString() : ""
        this.checkForCancerPlanAndProductType(productName, productType)
        this.setState({ spName, displayQuestions: true, loading: false, productName, productType, solIdList: solIdList ? solIdList : [], selectedValue: defaultSolId, selectedFromList: solId, requestSource: requestSource ? requestSource.toLowerCase() : '', isCasePassedStageFour, pfS3Path: dataFromToken?.pdfPath, showOtpPage: dataFromToken?.otpFlag === "Yes", proposalNo, pdfFlag: dataFromToken?.pdfFlag })
      } else {
        this.setState({ err: true, errMsg: response.data.response.msgInfo.msgDescription, loading: false })
      }
    }).catch(err => {
      console.log(err)
      this.setState({ err: true, loading: false, errMsg: 'Something went wrong, please try later.' })
    })
  }

  textFieldValidationOnSubmit = () => {
    let questionsWithTextBox = ["Q3", "Q4", "Q5", "Q7"]
    let allQuestions = JSON.parse(JSON.stringify(this.state.questions))
    let textFields = allQuestions.filter(q => questionsWithTextBox.includes(q.questionId) && q.answer == 'Yes')
    let answerWithAdditionalInfo = textFields.length ? textFields.filter(tf => tf.additionalInformation.length >= 3) : []
    // console.log(textFields)
    // console.log(answerWithAdditionalInfo)
    if (this.state.sellerDisclosure === 'Yes') {
      if (textFields.length === answerWithAdditionalInfo.length) {
        // console.log("valid text field")
        return true
      } else {
        // console.log("not valid text field")
        return false
      }
    } else {
      return true
    }
  }

  validateForm = () => {
    const { showDeclarationForCancer } = this.state;
    // let minimumPeriodLength = ( productName !== "Max Life Cancer Insurance Plan" && (productType.toLocaleLowerCase() == "trad" ||productType.toLocaleLowerCase() == "combo") ) ? -1 : 0;
    let minimumPeriodLength = showDeclarationForCancer ? 0 : -1;
    if (this.state.sellerDisclosure === 'Yes') {
      let allQuestions = JSON.parse(JSON.stringify(this.state.questions))
      let filterAnswerFromQuestions = allQuestions.filter(qst => qst.answer !== undefined && qst.answer.length)
      if (allQuestions.length - 1 === filterAnswerFromQuestions.length && this.state.period.length > minimumPeriodLength && this.state.periodUnit.length > minimumPeriodLength) {
        return true
      } else {
        return false
      }
    } else {
      if (this.state.sellerNonDisclosure === 'Yes' && this.state.period.length > minimumPeriodLength && this.state.periodUnit.length > minimumPeriodLength) {
        return true
      } else {
        return false
      }

    }
  };
  handleDropDown = (e) => {
    const { name, value } = e.target
    this.setState({ [name]: value })
  }
  handlePrimaryRadioButtons = (e, name) => {
    let allQuestions = JSON.parse(JSON.stringify(this.state.questions))
    let [Q1, Q2] = allQuestions.filter(q => q.questionId == "Q1" || q.questionId == "Q2")
    let q1Answered = true
    let q2Answered = true
    if (Q1.answer == "Yes") {
      q1Answered = false
    } else {
      q1Answered = true
    }
    if (Q2.answer == "Yes") {
      q2Answered = false
    } else {
      q2Answered = true
    }
    // const { name, value } = e.target
    const value = e
    if (name === 'sellerDisclosure' && (value == 'Yes' || value == 'No')) {
      this.setState({ sellerNonDisclosure: '', declaration: false, requiredQuestion1: q1Answered, requiredQuestion2: q2Answered })
    }
    if (name === 'sellerNonDisclosure' && (value == 'Yes' || value == 'No')) {
      this.setState({ sellerDisclosure: '', requiredQuestion1: false, requiredQuestion2: false, declaration: true })
    }
    this.setState({ [name]: value })
  }
  handleRequiredQuestionValidation = (questionId, response) => {
    if (response === 'No') {
      if (questionId === 'Q1') {
        this.setState({ requiredQuestion1: true })
      }
      if (questionId === 'Q2') {
        this.setState({ requiredQuestion2: true })
      }
    } else {
      if (questionId === 'Q1') {
        this.setState({ requiredQuestion1: false })
      }
      if (questionId === 'Q2') {
        this.setState({ requiredQuestion2: false })
      }
    }
  }
  onPopUpClose = () => {
    let allQuestions = JSON.parse(JSON.stringify(this.state.questions))
    let qstId = JSON.parse(JSON.stringify(this.state.popupFor))
    let popUpForQuestion = allQuestions.filter((qst => qst.questionId == qstId))
    if (popUpForQuestion.length) {
      popUpForQuestion[0].answer = ''
    }
    this.setState({ questions: allQuestions, showPopup: false, popupMsg: '' })
  }
  handleInfoPopUp = () => {
    if (this.state.info) {
      this.setState({ info: false })
    } else {
      this.setState({ info: true })
    }
  }
  handleRadioChange = (event) => {
    let allQuestions = JSON.parse(JSON.stringify(this.state.questions))
    const { name, value } = event.target
    let currentQuestion = allQuestions.filter(qst => qst.questionId == name)
    this.handleRequiredQuestionValidation(name, value)
    if (currentQuestion.length) {
      if (value === 'No') {
        if (name === 'Q1' || name === 'Q2') {
          let errMsgForQ1 = 'Please meet the customer personally in order to get the proposal processed further.'
          let errMsgForQ2 = 'Please explain the product features, benefits & other relevant terms & conditions to customer in order to get the proposal processed further.'
          currentQuestion[0].err = true
          currentQuestion[0].errMsg = name == 'Q1' ? errMsgForQ1 : errMsgForQ2
        } else {
          currentQuestion[0].err = true
        }
      } else {
        currentQuestion[0].err = false
      }
      currentQuestion[0].answer = value
      this.setState({ questions: allQuestions })
    } else {
      return
    }
  };
  handleSubQuestions = (e) => {
    const { name, value, type, id } = e.target
    console.log(name, value)
    let allQuestions = JSON.parse(JSON.stringify(this.state.questions))
    let questionWithSubQuestions = allQuestions.filter(qst => qst.subQuestions && qst.subQuestions.length)
    let currentSubQuestion = questionWithSubQuestions[0].subQuestions.filter(sq => sq.questionId == name)
    // console.log(currentSubQuestion[0])
    if (type == 'radio') {
      currentSubQuestion[0].answer = value
    } else if (type == 'text') {
      let currentField = currentSubQuestion[0].fields.filter(f => f.id == id)
      // console.log(currentField[0].value=value)
      currentField[0].value = value
    }
    this.setState({ questions: allQuestions })

  }
  handleChange = (e) => {
    const { name, value } = e.target
    let allQuestions = JSON.parse(JSON.stringify(this.state.questions))
    let currentQuestion = allQuestions.filter(qst => qst.questionId == name)
    if (currentQuestion.length) {
      currentQuestion[0].additionalInformation = value
      this.setState({ questions: allQuestions })
    } else {
      return
    }
  }
  handleChecbox = (e) => {
    const { name, checked } = e.target
    console.log(name, checked)
    if (this.state.declaration) {
      this.setState({ [name]: false })
    } else {
      this.setState({ [name]: true })
    }
  }

  submitForm = (e) => {
    let [param, quoteId] = window.location.search.split('=')
    console.log("param", param);
    this.setState({ loading: true })
    e.preventDefault()
    const { url, body } = getApiData('sellerConsentFormData')
    let allQuestions = JSON.parse(JSON.stringify(this.state.questions))
    let responsesForSubmission = allQuestions.map(qst => {
      delete qst.type
      delete qst.questionText
      delete qst.err
      delete qst.errMsg
      delete qst.subQuestions
      return qst
    })
    if (this.state.sellerDisclosure === 'Yes') {
      body.request.payload.sellerDisclosure = true
      body.request.payload.questions = responsesForSubmission
    } else {
      body.request.payload.sellerDisclosure = false
      body.request.payload.questions = []
    }
    body.request.payload.value = quoteId
    body.request.payload.period = this.state.period
    body.request.payload.periodUnit = this.state.periodUnit

    if (this.state.requestSource === "thanos") {
      body.request.payload.selectedSolId = this.state.selectedFromList
    }

    // console.log(url, body)
    axios.post(url, body).then(response => {
      if (response.data.response.msgInfo.msgCode == 200) {
        this.setState({ displayQuestions: false, successMsg: response.data.response.msgInfo.msgDescription })
      } else {
        this.setState({ err: true, errMsg: response.data.response.msgInfo.msgDescription, loading: false, displayQuestions: false })
      }
      this.setState({ loading: false })
    }).catch(err => {
      console.log(err)
      this.setState({ err: true, loading: false, displayQuestions: false, errMsg: 'Something went wrong, please try later.' })
    })
  }

  handleSearch = (e) => {
    let searchKey = e.target.value
    this.setState({ selectedValue: searchKey, selectedFromList: null })
    let options = JSON.parse(JSON.stringify(this.state.solIdList))
    options = options.sort((a, b) => a.branchId.localeCompare(b.branchId, undefined, { numeric: true, sensitivity: 'base' }))
    let filteredOpts = []
    options.forEach((opt) => {

      if (!(opt.branchId.toString().toLowerCase().search(searchKey.toLowerCase()))) {
        filteredOpts.push(opt)
      }

    })

    this.setState({ filteredOptions: filteredOpts })
  }

  onSelect = (option) => {
    this.setState({ selectedValue: option.toString(), selectedFromList: option, filteredOptions: [] })
  }

  focusOnSearch = (e) => {
    const solIdInput = document.getElementById('sol-id')
    solIdInput.focus()
  }
  setAllSolIds = (e) => {
    let AllSolIDs = JSON.parse(JSON.stringify(this.state.solIdList))
    this.setState({ filteredOptions: AllSolIDs })
  }

  checkBackendData = () => {
    const { requestSource, selectedFromList } = this.state

    if (requestSource === "thanos" && selectedFromList === null) {
      return true
    }
    else {
      return false
    }

  }

  onIdle = () => {
    localStorage.setItem("showNewUI", "Y")
    this.props.history.push('/blocked_journey?s=sd');
  }

  render() {
    const { info, successMsg, displayQuestions, spName, productName, productType, err, sellerDisclosure, questions,
      errMsg, sellerNonDisclosure, showDeclarationForCancer, filteredOptions, selectedValue,
      requestSource, pdfFlag, pfS3Path, showPfForm, showOtpPage, jwtToken, proposalNo } = this.state

    if (showOtpPage) {
      return (
        <IdleTimer
          timeout={(pdfFlag?.toLowerCase() === "y" || showOtpPage) ? IDLE_USER_TIMEOUT : IDLE_USER_TIMEOUT * 48}
          onIdle={this.onIdle}
        >

          <SDOtp
            setShowOtpPage={(val) => this.setState({ showOtpPage: val })}
            jwtToken={jwtToken}
            setJwtToken={(val) => this.setState({ jwtToken: val })}
            proposalNo={proposalNo}
          />
        </IdleTimer>
      )
    }

    return (
      <IdleTimer
        timeout={(pdfFlag?.toLowerCase() === "y" || showOtpPage) ? IDLE_USER_TIMEOUT : IDLE_USER_TIMEOUT * 48}
        onIdle={this.onIdle}
      >
        {
          showPfForm && (
            <div className="pf-form-container">
              <div className={`biPageContent ${isIOSDevice() ? 'iosDvce' : ''}`}>
                {/* {loading && <DotsLoader msg={translate(BI_LOADING_TEXT)} />} */}
                <BenefitIllustration setIsViewLoaded={(val) => this.setState({ isViewLoaded: val })} pdfUrl={pfS3Path} isSDPage={true} closePage={() => this.setState({ showPfForm: false })} />
              </div>
              <div className="button_div_unified pf-form">
              <Button
                  buttonType="primary"
                  width="154"
                  onClick={() => this.setState({ showPfForm: false })}
                >
                  Close
                </Button>
              </div>
            </div>
          )
        }
        {this.state.loading && <DotsLoader msg="Please wait" />}
        {successMsg.length > 0 ? <div className="display_text">
          <div style={{
            color: '#00236e',
            fontSize: '16px',
            fontWeight: '700',
            marginBottom: '0.5rem'
          }}>{successMsg}</div>
        </div> : null}
        {err ? <Error errorMsg={errMsg} /> : null}
        {displayQuestions ? <div className="search-form-sel-dec">
          <div>
            <h2 className="declaration-sel-dec">Seller Declaration Form </h2>
          </div>
          <div className="declaration-text-sel-dec">
            <DeclarationText isCancerPlan={showDeclarationForCancer} spName={spName} productType={productType.toLowerCase()} productName={productName.toLowerCase()} handleDropDown={this.handleDropDown} />
          </div>
          {
            requestSource === "thanos" &&

            <div
              className='sol-select-box'

            >
              <label> <b>Select Sol Id</b> </label>
              <input className='form-control-sol-id' id="sol-id" placeholder="Select" onFocus={this.setAllSolIds} value={selectedValue} onChange={this.handleSearch} />
              {/* <div className="expand-more-icon-cntnr" > */}
              <ExpandMoreIcon className="expand-more-icon-cntnr" onClick={this.focusOnSearch} />
              {/* </div> */}

              {filteredOptions.length > 0 && <div className='filter-option-cntnr' >
                {filteredOptions.map((fOpt) => (<p className='filter-opt' key={fOpt.branchId} onClick={() => this.onSelect(fOpt.branchId)} >{fOpt.branchId}</p>))}
              </div>}
            </div>
          }
          <div style={{ height: "24px" }} ></div>
          <div className={this.state.sellerDisclosure == "Yes" ? 'primary-radios' : 'primary-radios disabled-text'} >
            <RadioButton
              label="A. In case you wish to disclose anything in addition to what has been disclosed by the prospect."
              name="sellerDisclosure"
              value="Yes"
              checked={sellerDisclosure === 'Yes' ? true : false}
              onChange={(e) => this.handlePrimaryRadioButtons(e, 'sellerDisclosure')}
            />
          </div>
          <div className={this.state.sellerNonDisclosure == "Yes" ? 'primary-radios' : 'primary-radios disabled-text'} >
            <RadioButton
              label="B. I agree with the declaration mentioned above and do not wish to disclose in addition to what is been disclosed by the prospect."
              name="sellerNonDisclosure"
              value="Yes"
              checked={sellerNonDisclosure === 'Yes' ? true : false}
              onChange={(e) => this.handlePrimaryRadioButtons(e, 'sellerNonDisclosure')}
            />
          </div>
          {sellerDisclosure == 'Yes' && !err ? (
            <form
              autoComplete="off"
              onSubmit={this.submitForm}
            >
              <div className="question-container">
                {questions.map((qst, i) => (
                  generateInputs(qst, this.handleRadioChange, this.handleChange, this.handleInfoPopUp, this.handleSubQuestions)
                ))}
              </div>
              <br></br>
            </form>
          ) : null}
          {sellerDisclosure == "Yes" ? <div className="declaration-checkbox">
            <input id="declaration" name="declaration" type="checkbox" onChange={this.handleChecbox} checked={this.state.declaration} />
            <label htmlFor="declaration" > I confirm having verified the existence; identity and address of the Life to be insured/ proposer & proofs have been submitted for the same. I hereby declare that the above statements are true to the best of my knowledge and belief.</label>
          </div> : null}
          {/* <div className="err-msg-cntnr">
            <p className="err-msg" >Please provide details if answer is 'YES' for "Q3","Q4","Q5","Q7"</p>
          </div> */}
          {(sellerDisclosure == "Yes" || sellerNonDisclosure == "Yes") && requestSource == "thanos" && selectedValue.length < 1 && <div className="err-msg-cntnr">
            <p className="err-msg" >Please select a sol Id.</p>
          </div>}
          <div className={`button_div_unified seller-declaration ${pdfFlag?.toLowerCase() === "y" ? "pf-form-btn" : ""}`}>
            <Button
              disabled={!this.validateForm() || !this.textFieldValidationOnSubmit() || this.state.loading || !this.state.declaration || this.state.requiredQuestion1 || this.state.requiredQuestion2 || this.checkBackendData()}
              // className="btn"
              onClick={this.submitForm}
              buttonType="primary"
              width="154"
            >
              Submit
            </Button>
          </div>
            {
              pdfFlag?.toLowerCase() === "y" && (
                <Button
                onClick={() => this.setState({ showPfForm: true})}
                buttonType="neutralLink"
                size="small"
                className="view-pf-form-btn"
                >
                  View Proposal Form
                </Button>
              )
            }
          {info ?
            <div className="pop-up-cntnr" >
              <div className="pop-up-text" >
                <p className="close-btn" onClick={this.handleInfoPopUp} >X</p>
                <InfoPopUp />
              </div>
            </div> : null}
        </div> : null}
     </IdleTimer>
    );
  }
}

export default SellerDeclaration;
